import { GradientText, SubText } from '../PasserCommande/PasserCommande.styles'
import React, { useEffect, useState } from 'react'
import {
	searchCommandesByDateForTransporter,
	searchCommandesAnnuléesByPrixMinMaxForTransporter,
	searchCommandesByIdForTransporter
} from '../../api/transporteurs'

import CourseACourseHorizontal from '../../Components/SingleCommandeHorizontal/CourseACourseHorizontal'
import DateRangePicker from '@wojtekmaj/react-daterange-picker'
import LayoutTransporter from '../../Components/LayoutTransporter/LayoutTransporter'
import MiseADispoHorizontal from '../../Components/SingleCommandeHorizontalForTransporteur/MiseADispoHorizontal'
import Select from 'react-select'
import { getCommandesAnnuleesbyTransporterId } from '../../api/commande'
import { useHistory } from 'react-router'
import { useSelector } from 'react-redux'
import UltimatePaginationBasic from '../../Components/Pagination/Pagination'
import toast from 'react-hot-toast'
import DetailCommandeModal from '../../Components/DetailCommande/DetailCommandeModal'
import { useTranslation } from 'react-i18next'

const moment = require('moment')
const SIZE = 10

function CommandeAnnuléesTransporter() {
	const history = useHistory()

	const transporterId = useSelector((state) => state.auth.user._id)
	const token = useSelector((state) => state.auth.token);
	const [modalIsOpenDetail, setModalIsOpenDetail] = useState(false)
	const [page, setPage] = useState(1)
	const [totalPages, setTotalPages] = useState(1)
	const [chargementEnCours, setChargementEnCours] = useState(false);
	const [isSearching, setIsSearching] = useState(false);
	const [commandes, setCommandes] = useState([])
	const [searchCriteria, setSearchCriteria] = useState('id')
	const [range, setRange] = useState([new Date(), new Date()])
	const [min, setMin] = useState(0)
	const [max, setMax] = useState(300)
	const [searchQueryId, setSearchQueryId] = useState('')
	const {t} = useTranslation();
	const [selectedOption, setSelectedOption] = useState({
		value: 'id', label: t("search_by_id")
	});
	const [selectedCommande, setSelectedCommande] = useState(null)
	const handleChange = (selectedOption) => {
		setSelectedOption(selectedOption);
		setSearchCriteria(selectedOption.value)
	};


	const fetchCommandes = async (page) => {
		setChargementEnCours(true);
		try {
			let res;
			if (isSearching) {
				if (searchCriteria === 'id') {
					res = await searchCommandesByIdForTransporter(searchQueryId, transporterId, 'annulees', token,);
				} else if (searchCriteria === 'prix') {
					res = await searchCommandesAnnuléesByPrixMinMaxForTransporter(min, max, transporterId, token, page, SIZE);
				} else if (searchCriteria === 'date') {
					let minDate = moment(range[0]).format();
					let maxDate = moment(range[1]).format();
					let offsetUTC = moment().format("Z");

					res = await searchCommandesByDateForTransporter(minDate, maxDate, transporterId, 'annulees', token, page, SIZE, offsetUTC);
				}
			} else {
				res = await getCommandesAnnuleesbyTransporterId(transporterId, page, SIZE, token)

			}
			setCommandes(res.commandes);
			setTotalPages(res.totalPages);
		} catch (error) {
			toast.error(t("transfer_request_err"), {
				style: {
					fontFamily: 'Montserrat',
				},
			});
		} finally {
			setChargementEnCours(false);
		}
	};

	const resetData = async () => {
		setIsSearching(false);
		setSearchQueryId('');
		setSearchCriteria("id")
		setSelectedOption({
			value: 'id', label: t("search_by_id")
		})
		setPage(1);
	};


	const handleSearch = () => {
		setIsSearching(true);
		setPage(1);
		fetchCommandes(1);
	};

	useEffect(() => {
		fetchCommandes(page);
	}, [page, isSearching])
	const [isSmallScreen, setSmallScreen] = useState(() => window.innerWidth < 1024);


	useEffect(() => {
		const checkIfMobile = () => {
			setSmallScreen(window.innerWidth < 1024);
		};
		window.addEventListener('resize', checkIfMobile);

		return () => window.removeEventListener('resize', checkIfMobile);
	}, []);
	return (
		<LayoutTransporter>
			<div
				style={{
					width: '100%',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					flexDirection: 'column',
					paddingTop: '2rem',
					paddingBottom: '4rem',
					paddingLeft: '1.5rem',
					paddingRight: '1.5rem',
				}}
			>
				<GradientText
					style={{
						fontSize: isSmallScreen ? '2rem' : '2.5rem'
					}}
				>{t("cancelled_p").toUpperCase()}</GradientText>
				<span
					style={{
						fontFamily: 'Montserrat',
						color: '#262626',
						marginTop: '0.5rem',
						textAlign: 'center',
						fontSize: '1rem',
					}}
				>
					{t("cancelled_subtext")}

				</span>

				<div
					style={{
						width: '100%',
						fontFamily: 'Montserrat',
						marginBottom: '2rem',
						marginTop: '1rem',
						display: 'flex',
						flexDirection: isSmallScreen ? 'column' : 'row',
						gap: isSmallScreen ? '10px' : '0'
					}}
				>
					<div
						style={{
							width: isSmallScreen ? '100%' : '350px',
							fontFamily: 'Montserrat',
							marginRight: '1rem',
						}}
					>
						<Select
							isSearchable={false}
							options={[
								{ value: 'id', label: t("search_by_id") },
								{ value: 'prix', label: t("price") },
								{ value: 'date', label: t("transport_date") },
							]}
							styles={{
								option: (provided, state) => ({
									...provided,
									fontFamily: 'Montserrat',
								}),
								control: (provided, state) => ({
									...provided,
									height: '3rem',
									minHeight: 'fit-content',
								}),
								valueContainer: (base) => ({
									...base,
									maxHeight: '3rem',
									fontSize: isSmallScreen ? '14px' : '16px',
								}),
							}}
							value={selectedOption}
							onChange={handleChange}
							menuPortalTarget={document.querySelector('body')}
						/>
					</div>
					{searchCriteria === 'id' ? (
						<input
							style={{
								padding: '0.4rem',
								borderRadius: 5,
								border: '1px solid #E4EAF0',
								height: '3rem',
								width: isSmallScreen ? '100%' : '20rem',
								fontFamily: 'Montserrat',
							}}
							value={searchQueryId}
							onChange={(e) => setSearchQueryId(e.target.value)}
							placeholder={t("search")}
						/>
					) : null}
					{searchCriteria === 'prix' ? (
						<>
							<input
								type='number'
								style={{
									padding: '0.4rem',
									borderRadius: 5,
									border: '1px solid #E4EAF0',
									height: '3rem',
									width: isSmallScreen ? '100%' : '20rem',
									fontFamily: 'Montserrat',
									marginRight: '1rem',
								}}
								value={min}
								onChange={(e) => {
									setMin(Number(e.target.value))
								}}
								placeholder='Prix min'
							/>
							<input
								type='number'
								style={{
									padding: '0.4rem',
									borderRadius: 5,
									border: '1px solid #E4EAF0',
									height: '3rem',
									width: '20rem',
									fontFamily: 'Montserrat',
								}}
								value={max}
								onChange={(e) => {
									setMax(Number(e.target.value))
								}}
								placeholder='Prix max'
							/>
						</>
					) : null}

					{searchCriteria === 'date' ? (
						<DateRangePicker onChange={setRange} value={range} />
					) : null}

					<button
						onClick={handleSearch}
						style={{
							padding: '0.6rem 1rem',
							height: '3rem',
							background: '#C9D5F7',
							border: 'none',
							cursor: 'pointer',
							color: '#1C63C5',
							borderRadius: 7,
							marginLeft: isSmallScreen ? '0' : '1rem',
							width: isSmallScreen ? '100%' : '',
							fontFamily: 'Montserrat',
							fontWeight: 'bold',
						}}
					>
						{t("search")}
					</button>

					<button
						onClick={resetData}
						style={{
							padding: '0.6rem 2rem',
							height: '3rem',
							background: '#C9D5F7',
							border: 'none',
							cursor: 'pointer',
							color: '#1C63C5',
							borderRadius: 7,
							marginRight: isSmallScreen ? '0' : '1rem',
							marginLeft: isSmallScreen ? '0' : '1rem',
							fontFamily: 'Montserrat',
							fontWeight: 'bold',
							width: isSmallScreen ? '100%' : ''
						}}
					>
						{t("clear")}
					</button>
				</div>
				{chargementEnCours ?
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							backgroundColor: 'white',
							marginTop: "10rem",
							marginBottom: "3rem"
						}}
					>
						<div className='customLoader'></div>
					</div>
					:
					<div
						style={{
							width: '100%',
							fontFamily: 'Montserrat',
							marginBottom: 5,
						}}
					>
						{commandes.length === 0 ?
							<span
								style={{
									fontFamily: 'Montserrat',
									color: '#262626',
									marginTop: '0.5rem',
									textAlign: 'center',
									paddingLeft: "400px"
								}}

							>
								{t("no_orders_msg")}
							</span>
							: commandes.map((commande) => {
								if (commande.type_commande === 'course-a-course') {
									return (
										<CourseACourseHorizontal
											key={commande._id}
											commande={commande}
											hideAttribuer
											hidecancel
											hideRecu
											hidefacture
											hideUpdate
											hideStatus
											onClickDetails={() => {
												setSelectedCommande(commande._id)
												setModalIsOpenDetail(true)
											}}
											onClickSignaler={() => {
												history.push(
													`/transporter/transports/${commande._id}/signaler`
												)
											}}
										/>
									)
								} else {
									return (
										<MiseADispoHorizontal
											key={commande._id}
											commande={commande}
											hideAttribuer
											hidecancel
											hidefacture
											hideStatus
											hideRecu
											hideUpdate
											hideSignaler
											onClickDetails={() => {
												setSelectedCommande(commande._id)
												setModalIsOpenDetail(true)
											}}

										/>
									)
								}
							})}
					</div>
				}
				<div
					style={{
						width: '100%',
						display: 'flex',
						flexDirection: 'row',
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					<UltimatePaginationBasic
						currentPage={page}
						totalPages={totalPages}
						onChange={(newPage) => setPage(newPage)}
					/>
				</div>
				<DetailCommandeModal
					isOpen={modalIsOpenDetail}
					onClose={() => setModalIsOpenDetail(false)}
					commandeId={selectedCommande}
				/>
			</div>

		</LayoutTransporter>
	)
}

export default CommandeAnnuléesTransporter